import Vue from "vue";
// 价格千分位自定义过滤器
Vue.filter('numFormat', function (value) {
  if (!value) return 0
  return Number(value).toLocaleString()
})


// WEBPACK FOOTER //
// ./src/utils/number.js